/**
 * To corespond with level mapping
 */
import mapF1StaticData from 'config/f1Info';
import mapF2StaticData from 'config/f2Info';
import mapF3StaticData from 'config/f3Info';
import mapF4StaticData from 'config/fl4Info';
import mapF0StaticData from 'config/f0Info';

export default function switchMapInfoSet(floorLevel) {
  let result;
  switch (floorLevel) {
    case 0: 
      result = mapF0StaticData;
      break;
    case 1: 
      result = mapF1StaticData;
      break;
    case 2:
      result = mapF2StaticData;
      break;
    case 3:
      result = mapF3StaticData;
      break;
    case 4:
      result = mapF4StaticData;
      break;
    default:
      result = null;
      break;
  }

   return result;
}